import { useTranslation, NAMESPACES } from '@i18n';
import clsx from 'clsx';
import React from 'react';

import { Icon } from '../Icon/Icon';

import styles from './MethodBadge.module.scss';

interface MethodBadgeProps {
  method: 'upload' | 'synthetic';
  className?: string;
}

export const MethodBadge: React.FC<MethodBadgeProps> = ({ method, className }) => {
  const { t } = useTranslation(NAMESPACES.DATASET);

  if (method === 'upload') {
    return (
      <span className={clsx(styles.methodBadge, styles.methodBadgeUpload, className)}>
        <Icon
          name="upload"
          className={styles.methodBadgeIcon}
        />
        {t('dataset:inputs.uploadedDataset')}
      </span>
    );
  }

  return (
    <span className={clsx(styles.methodBadge, styles.methodBadgeSynthetic, className)}>
      <Icon
        name="sparkles"
        className={styles.methodBadgeIcon}
      />
      Synthetic generation
    </span>
  );
};
